export default "__VITE_ASSET__5eCLwr2C__"